<template>
    <Toast />
    <div class="p-grid">
        <div class="p-col-12">
            <div class="p-d-flex p-ai-center p-jc-between p-flex-column p-flex-lg-row p-mb-1">
                <h5>Hosts Users</h5>
            </div>
            <div class="card">
                <div class="p-d-flex p-ai-center p-flex-column p-flex-lg-row p-mb-1">
                    <div class="p-d-flex p-mr-3">
                        <Dropdown v-model="emp_name" :options="adminList" @change="getAdminUserDetails($event)"
                            optionLabel="label" appendTo="body" class="p-text-capitalize" placeholder="Select admin"
                            :style="{ minWidth: '200px' }" />
                    </div>
                    <div class="p-d-flex p-mr-3">
                        <Dropdown v-model="host_name" :options="hostList" @change="getHostUserDetails($event)"
                            optionLabel="label" appendTo="body" class="p-text-capitalize" placeholder="Select host"
                            :style="{ minWidth: '200px' }" />
                    </div>
                    <div class="p-d-flex ">
                        <Dropdown v-model="branch_name" :options="branchList" @change="getHostBranchEmpDetails($event)"
                            optionLabel="label" appendTo="body" class="p-text-capitalize" placeholder="Select branch"
                            :style="{ minWidth: '200px' }" />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <TabView @tab-change="getTabEvents" v-if="hostId != 0">
        <TabPanel header="Host Users">
            <div class="card">
                <DataTable :value="HostUserDetailsList" :lazy="true" :paginator="true" :rows="30"
                    :totalRecords="HostUsertotalRecords" :loading="loading" @page="onPageUser" class="p-datatable-users"
                    data-key="ad1" :rowHover="true"
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                    :style="{ 'overflow-wrap': 'break-word' }">
                    <template #empty> No data found. </template>
                    <template #loading> Loading data. Please wait... </template>
                    <Column header="User Name" headerStyle="width: 30%">
                        <template #body="{ data }">

                            <div class="p-text-capitalize overflow-span">
                                <span v-if="data.ad19 != null && data.ad19 != ''">
                                    <img :src="data.ad19" height="50" width="50"
                                        style="vertical-align: middle; border-radius: 75px" />
                                </span>
                                <span v-else>
                                    <img src="/assets/layout/images/widgets/Image_not_available.png" height="50"
                                        width="50" style="vertical-align: middle; border-radius: 75px" />
                                </span>
                                <span> &nbsp; {{ data.ad9 ? data.ad9 : "-" }}
                                </span>
                            </div>
                        </template>
                    </Column>

                    <Column header="Designation" headerStyle="width: 20%">
                        <template #body="{ data }">
                            <span class="overflow-span p-text-capitalize">
                                {{ data.ad11 ? data.ad11 : "-" }}</span>
                        </template>
                    </Column>
                    <Column header="Email Id" headerStyle="width: 20%">
                        <template #body="{ data }">
                            <span class="overflow-span" v-if="allow_to_display_email_id">
                                {{ data.ad18 ? data.ad18 : "-" }}
                            </span>
                            <span class="overflow-span" v-else>
                                {{ data.ad18 ? maskEmail(data.ad18) : "-" }}
                            </span>
                        </template>
                    </Column>
                    <Column header=" Contact Number" headerStyle="width: 15%">
                        <template #body="{ data }">
                            <span v-if="allow_to_display_mobile_number">{{ data.ad15 ? data.ad15 : "-" }}</span>
                            <span v-else>{{ data.ad15 ? maskMobileNumber(data.ad15) : "-" }}</span>
                        </template>
                    </Column>
                    <Column header="Status" headerStyle="width: 15%" class="p-text-center">
                        <template #body="{ data }">
                            <div class="p-text-capitalize overflow-span">
                                <div v-if="data.ad44 == 1"> Active </div>
                                <div v-else-if="data.ad44 == 2"> Temporary suspended </div>
                                <div v-else> Permanently suspended</div>
                            </div>
                        </template>
                    </Column>
                </DataTable>
                <Toast />
            </div>
        </TabPanel>
    </TabView>
</template>
<script>
import ApiService from '../../service/ApiService';
import router from '@/router';

export default {
    data() {
        return {
            adminList: [],
            hostList: [],
            branchList: [],
            emp_name: '',
            host_name: '',
            branch_name: '',
            hostData: [],
            loading: false,
            HostUserDetailsList: [],
            Hostuserdatadisplayflag: true,
            HostUsertotalRecords: 0,
            tabIndex: 0,
            page_no: 0,
            itemsPerPage: 30,
            adminId: 0,
            hostId: 0,
            branchId: 0,
            allow_to_display_mobile_number: 0,
            allow_to_display_email_id: 0,
        };
    },
    ApiService: null,
    created() {
        this.ApiService = new ApiService();
    },
    mounted() {
        this.getAdminListOnly();

        const localdata = JSON.parse(localStorage.user);
        this.allow_to_display_mobile_number = localdata.allow_to_display_mobile_number;
        this.allow_to_display_email_id = localdata.allow_to_display_email_id;
        // this.getHostAllDetails({ clientId: this.routeParam.clientId, hostId: this.routeParam.hostId });
        // this.getHostUserDetails({ clientId: this.routeParam.clientId, hostId: this.routeParam.hostId, page_no: this.page_no, itemsPerPage: this.itemsPerPage });
    },
    methods: {
        getAdminListOnly(e) {
            this.ApiService.getAdminListOnly(e).then((data) => {
                if (data.status == 200) {
                    this.adminList = data.data.records;
                } else {
                    this.adminList = null;
                }
            });
        },
        getAdminUserDetails(e) {
            this.loading = true;
            this.adminId = e.value.value;

            this.hostList = [];
            this.branchList = [];
            this.getHostListOnly(e);

            this.hostId = 0;
            this.branchId = 0;

        },
        getHostListOnly(e) {
            this.hostList = [];
            this.ApiService.getHostListOnly({ clientId: e.value.value }).then((data) => {
                if (data.status == 200) {
                    this.hostList = data.data.records;
                    this.hostId = 0;
                    this.branchId = 0;
                } else {
                    this.hostList = null;
                }
            });
        },
        getHostUserDetails(e) {
            this.loading = true;
            if (e) {
                this.page_no = 0;
                this.hostId = e.value.value;
            }

            this.ApiService.getHostUserDetails({ clientId: this.adminId, hostId: this.hostId, page_no: this.page_no, itemsPerPage: this.itemsPerPage }).then((data) => {
                if (data.success === true) {
                    this.HostUserDetailsList = data.data;
                    this.HostUsertotalRecords = data.count;
                    this.loading = false;
                    this.Hostuserdatadisplayflag = true;

                    if (e) {
                        this.getHostBranchListOnly(e);
                    }
                }
            });
        },

        getHostBranchListOnly(e) {
            this.hostId = e.value.value;
            this.branchList = [];
            this.branchId = 0;
            this.ApiService.getHostBranchesOnly({ clientId: this.adminId, hostId: e.value.value }).then((data) => {
                if (data.status == 200) {
                    this.branchList = data.data;
                } else {
                    this.branchList = null;
                }
            });
        },
        getHostBranchEmpDetails(e) {
            if (e) {
                this.page_no = 0;
                this.branchId = e.value.value;
            }
            this.loading = true;
            this.ApiService.getHostBranchesUserDetails({ clientId: this.adminId, hostId: this.hostId, branchId: this.branchId, page_no: this.page_no, itemsPerPage: this.itemsPerPage }).then((data) => {
                if (data.success === true) {
                    this.HostUserDetailsList = data.data.result;
                    this.HostUsertotalRecords = data.data.count;
                    this.loading = false;
                    this.visitorsdatadisplayflag = true;
                    this.admin_list_status = false;
                    this.host_list_status = true;
                    this.branch_list_status = true;
                }
            });
        },

        // getHostBranchVisitorsDetails(e) {
        //     if (e) {
        //         this.page_no = 0;
        //         this.branchId = e.value.value;
        //     }
        //     this.loading = true;
        //     this.ApiService.getAllVisitorsDetailsByBranches({ clientId: this.adminId, hostId: this.hostId, branchId: this.branchId, page_no: this.page_no, itemsPerPage: this.itemsPerPage }).then((data) => {
        //         if (data.success === true) {
        //             this.HostUserDetailsList = data.data.result;
        //             this.HostUsertotalRecords = data.data.count;
        //             this.loading = false;
        //             this.visitorsdatadisplayflag = true;
        //             this.admin_list_status = false;
        //             this.host_list_status = true;
        //             this.branch_list_status = true;
        //         }
        //     });
        // },
        // getHostAllDetails(ev) {
        //     this.loading = true;
        //     this.ApiService.getHostAllDetails(ev).then((data) => {
        //         if (data.status == 200) {
        //             this.hostData = data.data;
        //             this.loading = false;
        //         } else {
        //             this.hostData = '';
        //             this.loading = false;
        //         }
        //     });
        // },
        getTabEvents(ev) {
            this.page_no = 0;
            this.tabIndex = ev.index;
        },
        onPageUser(e) {
            this.loading = true;
            this.tabIndex = 0;
            this.page_no = e.page;
            this.getHostUserDetails();
        },
        // getHostUserDetails() {
        //     this.loading = true;
        //     this.ApiService.getHostUserDetails({ clientId: this.routeParam.clientId, hostId: this.routeParam.hostId, page_no: this.page_no, itemsPerPage: this.itemsPerPage }).then((data) => {
        //         if (data.success === true) {
        //             this.HostUserDetailsList = data.data;
        //             this.HostUsertotalRecords = data.count;
        //             this.loading = false;
        //             this.Hostuserdatadisplayflag = true;
        //         }
        //     });
        // },
        onlyNumber($event) {
            let keyCode = $event.keyCode ? $event.keyCode : $event.which;
            if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
                $event.preventDefault();
            }
        },
        formatCurrency(amount, currency = 'INR', minimumFractionDigits = 2) {
            let formatterAmount = new Intl.NumberFormat('en-IN', { minimumFractionDigits }).format(amount.toString());
            return (+0).toLocaleString('en-IN', { style: 'currency', currency })
                .replace('0.00', " " + formatterAmount)
        },
        goToBack() {
            router.push({
                name: "listhosts",
            });
        },
    },
};
</script>
<style scoped lang="scss"></style>
